import { fetchPersea } from "@/config/axios/config-axios";

export const getMetadataProject = async (params ={}) => {
    return await fetchPersea(`/substitution-variables`, 'GET', params);
};